/**
 * @typedef {Object.<string, *>} ItemKey
 * @todo add description
 */

/**
 * @typedef {ItemKey} Item
 * @property {jQuery.Deferred} promise
 * @property {number} [timeout] - Automatically reject the promise after X
 * milliseconds
 * @property {number} [timeoutId] - The Timeout ID of the promise timeout timer
 * @todo add description
 */

/**
 * Keep track of Active Promises
 * @class
 * @param {...string} [primaryKey] - Key(s) used to determine an item's
 * uniqueness
 */
// eslint-disable-next-line no-unused-vars
function ActivePromises(primaryKey) {
    this.activePromises = [];
    this.primaryKeys = [];

    // populate `this.primaryKeys`
    if (arguments.length) {
        for (var idx = 0; idx < arguments.length; idx++) {
            this.primaryKeys.push(arguments[idx]);
        }
    }
}

/**
 * List of active promises
 * @type {Array.<Item>}
 */
ActivePromises.prototype.activePromises = undefined;

/**
 * List of keys use to determine an item's uniqueness
 * @type {Array.<string>}
 */
ActivePromises.prototype.primaryKeys = undefined;

/**
 * Add item to list of active promises
 * @param {Item} activeItem
 */
ActivePromises.prototype.add = function (activeItem) {
    if (!this.isActive(activeItem)) {
        this.activePromises.push(activeItem);

        if (activeItem.timeout) {
            activeItem.timeoutId = setTimeout(
                function () {
                    // timed-out waiting for the promise to resolve
                    activeItem.promise.reject(new ActivePromises.TimeoutError(activeItem));
                }.bind(this),
                activeItem.timeout
            );
        }

        activeItem.promise.always(
            function () {
                clearTimeout(activeItem.timeoutId);
                this.remove(activeItem);
            }.bind(this)
        );
    }
};

/**
 * Remove item from list of active promises
 * @param {ItemKey} activeItem
 */
ActivePromises.prototype.remove = function (activeItem) {
    var index = this.indexOf(activeItem);

    if (index !== -1) {
        this.activePromises.splice(index, 1);
    }
};

/**
 * Get index of active promise item
 * @param {ItemKey} activeItem
 * @return {number} Index of active promise item (`-1` if not found)
 */
ActivePromises.prototype.indexOf = function (activeItem) {
    var index;
    var keyIndex;
    var length = this.activePromises.length;
    var keys = this.primaryKeys || Object.keys(activeItem);
    var numOfKeyValuesMatched = 0;
    var numOfKeyValuesToMatch = keys.length;

    var activeItemKeyValue;
    var providedItemKeyValue;

    for (index = 0; index < length; index++) {
        for (keyIndex = 0; keyIndex < numOfKeyValuesToMatch; keyIndex++) {
            activeItemKeyValue = this.activePromises[index][keys[keyIndex]];
            providedItemKeyValue = activeItem[keys[keyIndex]];

            if (providedItemKeyValue === activeItemKeyValue) {
                numOfKeyValuesMatched++;
            }
        }

        if (numOfKeyValuesMatched === numOfKeyValuesToMatch) {
            return index;
        }
    }

    return -1;
};

/**
 * Is given item currently active
 * @param {ItemKey} activeItem
 * @return {boolean}
 */
ActivePromises.prototype.isActive = function (activeItem) {
    return this.indexOf(activeItem) !== -1;
};

/**
 * Get active item
 * @param {ItemKey|number} activeItem
 * @return {Item|null}
 */
ActivePromises.prototype.get = function (activeItem) {
    var index;

    if (typeof activeItem === 'number') {
        index = activeItem;
    } else {
        index = this.indexOf(activeItem);
    }

    if (index !== -1) {
        return this.activePromises[index];
    } else {
        return null;
    }
};

/**
 * @class
 * @param {ItemKey} activeItem
 * @augments Error
 */
ActivePromises.TimeoutError = function (activeItem) {
    var timeoutSeconds = +(Math.round(activeItem.timeout / 1000 + 'e+1') + 'e-1');

    this.name = 'ActivePromises.TimeoutError';
    this.message = 'Promise timed out after ' + timeoutSeconds + ' seconds.';
    this.stack = new Error().stack;
    this.data = {};

    Object.keys(activeItem).forEach(function (key) {
        var blacklist = ['promise', 'timeoutId'];

        if (blacklist.indexOf(key) === -1) {
            this.data[key] = activeItem[key];
        }
    }, this);
};
ActivePromises.TimeoutError.prototype = Object.create(Error.prototype);
ActivePromises.TimeoutError.prototype.constructor = ActivePromises.TimeoutError;
ActivePromises.TimeoutError.prototype.toJSON = function () {
    return {
        message: this.message,
        name: this.name,
        stack: this.stack,
        data: this.data,
    };
};

export { ActivePromises };
